import { IGlobalizationData, IGlobalizationPagedQuery } from '../../models/components/translation';
import { actions } from '../constants/translations';
import * as actionTypes from '../../models/action/translation';


export function GetGlobalizationList(SearchedText: string, IsCustomized: boolean, Culture?: string, Take?: number, Skip?: number, Page?: number, callback?: () => void, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        SearchedText,
        IsCustomized,
        Culture,
        Take,
        Skip,
        Page,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_LIST_GLOBALIZATION
    };

}

export function SetGlobalizationList(results: Array<IGlobalizationData>, filters: IGlobalizationPagedQuery, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetGlobalizationList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_LIST_GLOBALIZATION
    };
}

export function UpdateGlobalization(globalizationId: string, globalizationKey: string, globalizationValue: string, culture: string, callback?: () => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGlobalization {
    return {
        globalizationId,
        globalizationKey,
        globalizationValue,
        culture,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_GLOBALIZATION
    };
}

export function RefereshGlobalizationList(globalizationData?: any, processType?: string): actionTypes.IRefreshGlobalization {
    return {
        globalizationData,
        processType,
        timestamp: Date.now(),
        type: actions.REFRESH_GLOBALIZATION_LIST
    };
}

export function DeleteGlobalization(globalizationId: string, globalizationKey: string, culture: string, callback?: () => void, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IDeleteGlobalization {
    return {
        globalizationId,
        globalizationKey,
        culture,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.DELETE_GLOBALIZATION
    };
}
